// extracted by mini-css-extract-plugin
export default {"parameters":"c838J","parameter":"Btnko"};